import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAirports, deleteAirport } from "../../../actions/admin/airport";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import AirportItem from "./AirportItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Airport Name", width: "tw:w-[240px]" },
  { key: "address", title: "Google Address", width: "tw:w-[380px]" },
  { key: "city", title: "City - Administrative area level 1", width: "tw:w-[280px]" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const AirportList = () => {
  const airport_state = useSelector((state) => state.airport);
  const { loading, airports } = airport_state;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAirports());
  }, [dispatch]);

  const delAirportfromPopup = () => {
    dispatch(deleteAirport(delId));
    setDelId(null);
  };

  return (
    <AdminPage title="Airport List" actions={<AdminCreateButton to="/admin/addairport" label="Add Airport" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this airport?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={delAirportfromPopup}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1260}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!airports?.length}
        emptyText="No airports found."
      >
        {airports?.map((item, index) => (
          <AirportItem key={item._id} airport={item} count={index} deleteAirport={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default AirportList;
